import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import SafeImage from './SafeImage';
import { themes as fallbackThemes } from '../mock';
import { useSettings } from '../store';
import { API } from '../api';

const ThemesSection = () => {
  const ref = useRef(null);
  const settings = useSettings();
  const [themes, setThemes] = useState(fallbackThemes);

  useEffect(() => {
    axios.get(`${API}/taxonomies?type=theme`).then((res) => {
      const list = Array.isArray(res.data) ? res.data : [];
      if (list.length === 0) return;
      setThemes(list.map((t) => ({
        slug: t.slug,
        name: t.name,
        image: t.image || '',
        fbType: t.fb_type || 'default',
      })));
    }).catch(() => {});
  }, []);

  const scroll = (dir) => {
    if (!ref.current) return;
    ref.current.scrollBy({ left: dir * 340, behavior: 'smooth' });
  };

  return (
    <section className="py-14 bg-[#eef4f8]">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-2 text-center">
          {settings.section_themes_title || 'Explore Destinations by Theme'}
        </h2>
        <p className="text-sm text-gray-500 text-center mb-8">Pick a vibe. We'll craft the trip.</p>

        <div className="relative">
          <button
            onClick={() => scroll(-1)}
            className="hidden md:flex absolute -left-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-[#0d64a8] text-white items-center justify-center shadow-lg hover:bg-[#0a548e] transition"
          >
            <ChevronLeft size={20} />
          </button>
          <button
            onClick={() => scroll(1)}
            className="hidden md:flex absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-[#0d64a8] text-white items-center justify-center shadow-lg hover:bg-[#0a548e] transition"
          >
            <ChevronRight size={20} />
          </button>

          <div ref={ref} className="flex gap-5 overflow-x-auto snap-x scroll-smooth pb-3" style={{ scrollbarWidth: 'none' }}>
            {themes.map((t) => (
              <Link
                to={`/theme/${t.slug}`}
                key={t.slug}
                data-card
                className="snap-start shrink-0 w-[240px] md:w-[280px] h-[280px] relative rounded-xl overflow-hidden group shadow-md hover:shadow-xl transition"
              >
                <SafeImage src={t.image} alt={t.name} fallbackType={t.fbType || 'default'} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute bottom-4 left-0 right-0 text-center text-white text-xl font-semibold tracking-wide">
                  {t.name}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThemesSection;
